import confetti from './confetti@2x.png'
import logo from './logo@2x.png'
import grid from './grid@2x.png'
import dots from './dots@2x.png'

import symbolOverview from './symbols@2x.png'
import symbol from './symbol@2x.png'

import settings from './settings@2x.png'
import setting from './setting@2x.png'

import shapes from './shapes@2x.png'
import shapeIcon from './shapeIcon@2x.png'

import depth from './depth@2x.png'

export default {
  confetti,
  logo,
  grid,
  dots,
  symbolOverview,
  symbol,
  settings,
  setting,
  shapes,
  shapeIcon,
  depth
}



// WEBPACK FOOTER //
// ./src/images/home/index.js